<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    width="70%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :readOnly="readOnly"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
        :readOnly="readOnly"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null
    };
  },
  props: {
    entry: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit
  },
  methods: {
    loadServerEntry: function(id) {
      this.editableEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_STOCK_ADJUSTMENT_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: id
          }
        })
        .then(response => {
          this.editableEntry = response.data.accountContext.stockAdjustment;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    updateServerEntry: function(stockAdjustment) {
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: UPDATE_STOCK_ADJUSTMENT_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(stockAdjustment, this.editableEntry.validations)
          }
        })
        .then(response => {
          var errors = response.data.updateStockAdjustment.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated");
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.updateServerEntry(this.editableEntry);
        this.resetForm();
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};
const LOAD_STOCK_ADJUSTMENT_QUERY = gql `
query ($id: ID!) {
  accountContext {
    stockAdjustment(id: $id) {
        id
        code
        date
        description
        isStockEntryType
        stockId
        stock {
          id
          name
        }
        stockAdjustmentReasonId
        stockAdjustmentReason {
          id
          name
        }
        stockAdjustmentItemsAttributes {
          id
          quantity
          price
          isNewItemInStock
          itemId
          item {
            id
            name
            unit {
              id
              name
            }
            brand {
              id
              name
            }
            typeText
          }
          packagingId
          packaging {
            id
            name
            size
            text
          }
          validations
        }
        consumedItemsAttributes {
          id
          itemId
          item {
            id
            name
            unit {
              id
              name
            }
            brand {
              id
              name
            }
          }
          packagingId
          packaging {
            id
            name
            text
            size
          }
          stockId
          stock {
            id
            name
          }
          quantity
          hasCropLimit
          unitQuantity
          validations
        }
        validations
      }
      allStocks {
        id
        name
        location
      }
      allStockAdjustmentReasons {
        id
        name
      }
    }
  }
`;

const UPDATE_STOCK_ADJUSTMENT_MUTATION = gql `
  mutation($input: StockAdjustmentUpdateInputObject!) {
    updateStockAdjustment(input: $input) {
      stockAdjustment {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>